// TODO: Import React module
import * as React from 'react';

// TODO: Import MUI module
import { } from '@mui/material';

// TODO: Import MUI icon
import { } from '@mui/icons-material';

// TODO: Import context
import { Context, } from '../Common/Context';
import { Text, } from '../Common/Text';

// TODO: Import custom component
import BoxSubPage from '../Common/BoxSubPage';
import BoxImage from '../Common/BoxImage';
import { BoxGridColumnsContainer, BoxGridColumnsFullWidth } from '../Common/BoxGridColumns';
import { ContentTitle, MultipleRows } from '../Common/TypographyTYH';

const CafeGeographie = () => {
    if (window.location.href.startsWith('http://localhost')) console.log('Component CafeGeographie Rendered');

    // TODO: Define useContext
    const context = React.useContext(Context);

    // TODO: Define Imperative Handle

    // TODO: Define variable

    // TODO: Define event

    // TODO: Return component
    return (
        <BoxSubPage
            id="CafeGeographie"
            image={'https://www.pohtyh.edu.hk/Files/CampusDevelopment/Slide_ACE.jpg'}
            title={Text.Top.Menu['CampusDevelopment'].Title[context.language]}
            subtitles={Text.Top.Menu['CampusDevelopment'].Subtitles}
        >
            <BoxGridColumnsContainer>
                <BoxGridColumnsFullWidth>
                    <MultipleRows rows={Text.CampusDevelopment.ACE.Intro[context.language]} />
                    <BoxImage
                        src="https://www.pohtyh.edu.hk/Files/CampusDevelopment/ACE/Intro.jpg"
                        sx={{ width: 1, }}
                        sxSkeleton={{ width: 1 }}
                    />
                    <MultipleRows rows={Text.CampusDevelopment.ACE.Section[context.language]} />
                    <ContentTitle text={Text.CampusDevelopment.ACE.Aerobic.Title[context.language]} />
                    <MultipleRows rows={Text.CampusDevelopment.ACE.Aerobic.Content[context.language]} />
                    <BoxImage
                        src="https://www.pohtyh.edu.hk/Files/CampusDevelopment/ACE/Aerobic.jpg"
                        sx={{ width: 1, }}
                        sxSkeleton={{ width: 1 }}
                    />
                    <ContentTitle text={Text.CampusDevelopment.ACE.FreeWeights.Title[context.language]} />
                    <MultipleRows rows={Text.CampusDevelopment.ACE.FreeWeights.Content[context.language]} />
                    <BoxImage
                        src="https://www.pohtyh.edu.hk/Files/CampusDevelopment/ACE/FreeWeight.jpg"
                        sx={{ width: 1, }}
                        sxSkeleton={{ width: 1 }}
                    />
                    <ContentTitle text={Text.CampusDevelopment.ACE.Equipment.Title[context.language]} />
                    <MultipleRows rows={Text.CampusDevelopment.ACE.Equipment.Content[context.language]} />
                    <BoxImage
                        src="https://www.pohtyh.edu.hk/Files/CampusDevelopment/ACE/Equipment.jpg"
                        sx={{ width: 1, }}
                        sxSkeleton={{ width: 1 }}
                    />
                    <ContentTitle text={Text.CampusDevelopment.ACE.Functional.Title[context.language]} />
                    <MultipleRows rows={Text.CampusDevelopment.ACE.Functional.Content[context.language]} />
                    <BoxImage
                        src="https://www.pohtyh.edu.hk/Files/CampusDevelopment/ACE/Functional.jpg"
                        sx={{ width: 1, mb:2 }}
                        sxSkeleton={{ width: 1 }}
                    />
                    <MultipleRows rows={Text.CampusDevelopment.ACE.Other.Content[context.language]} />
                    <BoxImage
                        src="https://www.pohtyh.edu.hk/Files/CampusDevelopment/ACE/Other.jpg"
                        sx={{ width: 1, }}
                        sxSkeleton={{ width: 1 }}
                    />
                </BoxGridColumnsFullWidth>
            </BoxGridColumnsContainer>
        </BoxSubPage>
    );
};

export default CafeGeographie;